{
  "name": "22-Farabi",
  "description": "22-tone 17-Limit Rational Intonation gamut, proposed by Abu Nasr Farabi (872-950), also known as al-Farabi, in his book Kitab al-Musiqa al-Kabir (\"The Great Book of Music\"). This maps a theoretical fretting of the oud, obtaining several commonly used divisions of the tetrachord. The gamut combines divisions (intervals) derived by combining primes 2, 3, 11, and 17. The chain of 9 subharmonic perfect fifths tuned below the fundamental also ends in four pitches one schisma lower than common 5-Limit ratios (45/32, 15/8, 5/4, 5/3). Thanks to Idin Samimi Mofakham for translation, analysis, and documentation.",
  "scale": [
    "256/243",
    "18/17",
    "12/11",
    "9/8",
    "32/27",
    "27/22",
    "8192/6561",
    "81/64",
    "4/3",
    "1024/729",
    "24/17",
    "16/11",
    "3/2",
    "128/81",
    "18/11",
    "32768/19683",
    "27/16",
    "16/9",
    "4096/2187",
    "32/17",
    "64/33",
    "2/1"
  ],
  "key_colors_mode": "manual",
  "short_description": "22-Farabi",
  "built_in_group": "Arabic and Persian Theoretical Systems",
  "key_labels": "note_names",
  "note_names": [
    "C",
    "D",
    "D",
    "D",
    "D",
    "E",
    "E",
    "E",
    "E",
    "F",
    "F",
    "G",
    "G",
    "G",
    "A",
    "A",
    "A",
    "A",
    "B",
    "B",
    "C",
    "C"
  ],
  "note_colors": [
    "#ffffff",
    "#d0d0d7",
    "#c3c3e9",
    "#cee3e2",
    "#ffffff",
    "#d0d0d7",
    "#cee3e2",
    "#fffae5",
    "#ffffff",
    "#ffffff",
    "#fffae5",
    "#c3c3e9",
    "#cee3e2",
    "#ffffff",
    "#d0d0d7",
    "#cee3e2",
    "#fffae5",
    "#ffffff",
    "#d0d0d7",
    "#fffae5",
    "#c3c3e9",
    "#cee3e2"
  ],
  "equivSteps": 22,
  "fundamental": 440,
  "reference_degree": 17,
  "center_degree": 0,
  "rSteps": 4,
  "drSteps": 1,
  "hexSize": 42,
  "rotation": -16.102113751
}
